export const updateDetalleTicketAction = (state) => {
  return {
    type: "UPDATE_DETALLE_TICKET",
    payload: state,
  };
};
